import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomTooltipModule } from '../custom-tooltip/custom-tooltip.module';
import { AidaEnabledTooltipComponent } from './aida-enabled-tooltip/aida-enabled-tooltip.component';
import { AidaFeatureUnavailableComponent } from './aida-feature-unavailable-tooltip/aida-feature-unavailable-tooltip.component';
import { AidaInfoTooltipComponent } from './aida-info-tooltip/aida-info-tooltip.component';
import { AidaChartToolTipComponent } from './aida-chart-tooltip/aida-chart-tooltip.component';

@NgModule({
  imports: [CommonModule, CustomTooltipModule],
  declarations: [
    AidaEnabledTooltipComponent,
    AidaFeatureUnavailableComponent,
    AidaInfoTooltipComponent,
    AidaChartToolTipComponent,
  ],
  exports: [
    AidaEnabledTooltipComponent,
    AidaFeatureUnavailableComponent,
    AidaInfoTooltipComponent,
    AidaChartToolTipComponent,
  ],
})
export class AidaTooltipModule {}
